export enum LayoutType {
  SINGLE = 'single',
  SPLIT = 'split',
  SPLIT_EXTEND = 'split-extend',
}

export enum LayoutMinHeight {
  NONE = 'none',
  MID = 'mid',
  FULL = 'full',
}
